import {Directive, ViewChild} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Pagination} from "@models/pagination.model";

@Directive()
export abstract class Paginator {

    errorMessage!: string;
    loading = false;

    @ViewChild("table") table: any;

    pagination: Pagination = new Pagination();

    offset: number = 0
    rows: any[]
    sortField: string
    order: string = 'asc'

    service: any
    filterForm: FormGroup

    reset(): void {
        this.filterForm.reset()
        this.filter()
    }

    filter(): void {
        this.loading = true
        this.pagination.onFilter(this.filterForm.value)
        this.refreshRows()
    }

    setPage(pageInfo) {
        this.loading = true
        this.pagination.start = pageInfo.offset
        this.table.offset = this.pagination.start
        this.refreshRows()
    }

    sort(pageInfo) {
        this.loading = true
        this.pagination.onSort(pageInfo.sorts[0].prop, pageInfo.sorts[0].dir)
        this.table.offset = this.pagination.start
        this.refreshRows()
    }

    refreshRows() {
        this.service.listPaginated(this.pagination).subscribe({
            next: (response) => {
                if (!response?.data?.length) {
                    this.rows = []
                    this.pagination.totalCount = 0;
                    this.loading = false;
                    return;
                }
                this.rows = response.data;
                this.pagination.totalCount = response.pagination.totalCount;
                this.loading = false;
            }
        })
    }
}
